import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ReportNote as NYYReportNote } from 'yankees-react-utils';
import { useOktaQuery, Notes } from '../data';

const ReportNote = ({ type, section, yearId, teamId, playerId, recordId, levelId, pitcherId,
    batterId, fxtype, fxsubtype, hasDataCallback, doesHaveSpanishDataCallback, onLoad, showInfo, showSpanish }) => {
    const queryNoteParams = { type, section, yearId, teamId, playerId, recordId, levelId, pitcherId, batterId, fxtype, fxsubtype };
    const { data, isLoading } = useOktaQuery(['reportNote', queryNoteParams], (t) => Notes.getReportNote(t, queryNoteParams));

    useEffect(() => {
        if (hasDataCallback && !isLoading) { // only call if this is defined, since it is optional callback
            hasDataCallback(data != null);
        }
        if (doesHaveSpanishDataCallback && !isLoading && data !== null && data.EsNote != null) { // only call if this is defined, since it is optional callback
            doesHaveSpanishDataCallback(true);
        }
        if (onLoad && !isLoading) onLoad(data);
    }, [isLoading, data, hasDataCallback, doesHaveSpanishDataCallback, onLoad]);

    return (
        <NYYReportNote isLoading={isLoading} note={data} showInfo={showInfo} showSpanish={showSpanish} />
    );
};

ReportNote.propTypes = {
    type: PropTypes.string.isRequired,
    section: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    yearId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    teamId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    playerId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    recordId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    levelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    pitcherId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    batterId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    fxtype: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    fxsubtype: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    hasDataCallback: PropTypes.func,
    doesHaveSpanishDataCallback: PropTypes.func,
    onLoad: PropTypes.func,
    showInfo: PropTypes.bool,
    showSpanish: PropTypes.bool,
};
ReportNote.defaultProps = {
    section: undefined,
    yearId: undefined,
    teamId: undefined,
    playerId: undefined,
    pitcherId: undefined,
    batterId: undefined,
    fxtype: undefined,
    fxsubtype: undefined,
    recordId: undefined,
    levelId: undefined,
    hasDataCallback: undefined,
    doesHaveSpanishDataCallback: undefined,
    onLoad: undefined,
    showInfo: false,
    showSpanish: false,
};

export default ReportNote;
